<template>
    <FullFillBox
        :pageID="1007"
        @permissionData="(data) => {
            this.permissionDetails = data
        }"
    >
        <h4>{{ $t('inventory_stock_write_off') }}</h4>
        <hr>
        <form @submit.prevent="dataToTable">
            <TopDataKeyBox
                ref="topDataKeyBox"
                :key-label="this.$t('inventory_stock_transfer_out')"
                :key-remarks-label="this.$t('inventory_stock_in_remarks')"
                :mode="'write_off'"
                @returnData="(returnData) => {
                    this.getWriteOffName = returnData['key']
                    this.getWriteOffRemarks = returnData['keyRemarks']
                }"
            />
            <hr>
            <div class="row">
                <FilterMainContentBox
                    ref="filterMainContentBox">
                    <FilterDetailContentBox
                        ref="filterDetailContentBox"
                        :mode="'need'"
                        :update-mode="this.updateMode"
                        @cancelUpdateMode="cancelUpdateMode"
                        @returnProductData="(getProduct) => {
                            if(getProduct.status === 0){
                                this.ctnQty = null
                                this.$refs.stockCalculatedLocationBox.clearData()
                            }else{
                                // use to let 'watch' to update the data
                                if(this.needReloadList === false){
                                    this.needReloadList = true
                                }else{
                                    this.randomNumber = new Date()
                                }
                                this.getComponentProduct = getProduct['details']
                                this.ctnQty = getProduct['details']['out_pack']
                            }
                        }"
                    >
                        <slot>
                            <div class="row">
                                <div class="col-md-12">
                                    <StockCalculatedLocationBox
                                        ref="stockCalculatedLocationBox"
                                        :getTime="this.randomNumber"
                                        :stockOutTempID="''"
                                        :productID="this.getComponentProduct['id']"
                                        @loc="(returnData) => {
                                            this.getComponentLocation = returnData
                                            if(this.getComponentLocation){
                                                this.getNowCanUseQty = returnData['qty'] - returnData['stockOutTempQty2'] - returnData['transTempQty2']
                                            }else{
                                                this.getNowCanUseQty = 0
                                            }
                                            this.canInputNumber = true
                                        }"
                                    />
                                </div>
                            </div>

                            <QtyProcessor
                                ref="qtyProcessor"
                                :ctn-qty="this.ctnQty"
                                :flag="this.canInputNumber"
                                @returnQty="(returnData)=>{
                                    this.getQty = returnData['qty']
                                    this.getCtn = returnData['ctn']
                                    if(this.getQty > this.getNowCanUseQty){
                                        this.$swal.fire({
                                            title: this.$t('error_stock_not_enough'),
                                            text: this.$t('error_stock_not_enough_details') + this.getNowCanUseQty + ', ' +
                                                  this.$t('error_stock_not_enough_get') + this.getQty,
                                            icon: 'warning'
                                        })
                                        this.$refs.qtyProcessor.clearMode()
                                    }
                                }"
                                style="margin-top: 5px;"
                            />
                            <div class="row" style="margin-top: 5px">
                                <div class="col-lg-2 col-form-label" style="text-align: left">
                                    {{ $t('inventory_stock_in_remarks') }}
                                </div>
                                <div class="col-lg-10"><input class="form-control" v-model="getRemarks"></div>
                            </div>
                        </slot>
                    </FilterDetailContentBox>
                </FilterMainContentBox>
            </div>
        </form>
        <hr>
        <div id="error_show" style="display: none">
            <p>{{ mainError }}</p>
            <p>
                <button class="btn btn-warning" type="button"
                        data-bs-toggle="collapse" data-bs-target="#collapseExample"
                        aria-expanded="false" aria-controls="collapseExample">
                    {{ $t('error_expand_error_details') }}
                </button>
            </p>
            <div class="collapse" id="collapseExample">
                <div id="errorDetailList"></div>
            </div>
        </div>

        <div ref="tabulatorTableUse"></div>

        <div class="row">
            <button class="btn btn-primary"
                    @click="uploadToServer"
                    style="width: 200px;margin: auto auto 5px auto">
                {{ $t('common_upload') }}
            </button>
        </div>
    </FullFillBox>
</template>

<script>
import Multiselect from "@vueform/multiselect";
import FullFillBox from "@/components/routerViewLocation/FullFillBox";
import TopDataKeyBox from "@/components/StockProcessComponents/TopDataKeyBox";
import FilterMainContentBox from "@/components/StockProcessComponents/FilterMainContentBox";
import FilterDetailContentBox from "@/components/StockProcessComponents/FilterDetailContentBox";
import QtyProcessor from "@/components/StockProcessComponents/QtyProcessor";
import StockCalculatedLocationBox from "@/components/StockProcessComponents/StockCalculatedLocationBox";
import {TabulatorFull as Tabulator} from "tabulator-tables";

export default {
    name: "InventoryWriteOffView",
    components: {
        Multiselect,
        FullFillBox,
        TopDataKeyBox,
        FilterMainContentBox,
        FilterDetailContentBox,
        QtyProcessor,
        StockCalculatedLocationBox,
    },
    data(){
        return{
            permissionDetails: {},
            getWriteOffName: '',
            getWriteOffRemarks: '',
            getRemarks: '',

            // each same time
            updateMode: false,
            updateItemID: '',
            getComponentProduct: '',
            getComponentLocation: '',
            ctnQty: null,
            tablePKID: 1,
            canInputNumber: false,
            getQty: '',
            getCtn: '',
            // loc
            needReloadList: '',
            randomNumber: '',
            getNowCanUseQty: '',
            //error
            mainError: '',
        }
    },
    methods: {
        async uploadToServer(){
            if(this.tabulator.getData().length === 0 || this.getWriteOffName.length === 0){
                this.$swal.fire({
                    title: this.$t('inventory_stock_in_error_data_required'),
                })
            }else{
                let data = {
                    'writeOffName': this.getWriteOffName,
                    'writeOffRemarks': this.getWriteOffRemarks,
                    'jsonData': this.tabulator.getData()
                }
                await this.$mainApi.post('api/inventory/write-off/', data)
                    .then(async response => {
                        document.getElementById('error_show').style.display = 'none'
                        let parent = document.getElementById('errorDetailList')
                        // clear old errors
                        parent.innerHTML = ""
                        if (response.data.status === 80) {
                            if (response.data.details.errors.error_row.length > 0) {
                                document.getElementById('error_show').style.display = 'block'
                                // Have Errors
                                // this.tabulator.setData(response.data.details.data.filter(a => response.data.details.errors.error_row.includes(a.id)))
                                this.tabulator.setData(response.data.details.data)
                                let getErrorList = response.data.details.errors.error_details
                                for (let i = 0; i < getErrorList.length; i++) {
                                    let htmlContent = await this.$serverErrorReturn(getErrorList[i]['details'])
                                    let subParent =
                                        "<div class='row' style='background-color: #d4d5e5;border: solid grey 1px;border-radius: 15px'>" +
                                        "<div class='col-3 my-auto'>" +
                                        "<h4><strong>" + this.$t('common_row') + " " + getErrorList[i]['id'] + "</strong></h4>" +
                                        "</div>" +
                                        "<div class='col-9'>" +
                                        "<p>" + getErrorList[i]['errors'] + "</p>" +
                                        htmlContent +
                                        "</div>" +
                                        "</div><br>"
                                    parent.innerHTML += subParent
                                }
                            } else {
                                this.$toast.success(this.$t('common_success'))
                                this.$router.go(0)
                            }
                        } else {
                            document.getElementById('error_show').style.display = 'block'
                            this.mainError = response.data.errors
                            let getErrorList = response.data.details
                            let htmlContent = await this.$serverErrorReturn(getErrorList)
                            let subParent =
                                "<div class='row' style='background-color: #d4d5e5;border: solid grey 1px;border-radius: 15px'>" +
                                "<div class='col-12'>" + htmlContent + "</div>" +
                                "</div><br>"
                            parent.innerHTML += subParent
                        }

                    })
            }
        },
        dataToTable(){
            // check if is need info is provided
            if(this.getComponentLocation['id'] && this.getComponentProduct['id'] && this.getCtn && this.getQty && this.getWriteOffName){
                let data = this.tabulator.getData()
                let isError = false

                let totalQtyCheck = data.filter(a=>
                    a.pid === this.getComponentProduct['id'] &&
                    a.lid === this.getComponentLocation['id'])
                if(this.updateMode === true){
                    // Don't calculate myself
                    totalQtyCheck = data.filter(a=>
                        a.pid === this.getComponentProduct['id'] &&
                        a.lid === this.getComponentLocation['id'] &&
                        a.id !== this.updateItemID)
                }

                // If all other same item qty + now input Qty is larger than Inv Can Use Qty = Error
                let totalExistedQty = 0
                for(let i=0;i<totalQtyCheck.length;i++){
                    totalExistedQty += totalQtyCheck[i]['qty']
                }
                if(this.getQty + totalExistedQty > this.getNowCanUseQty){
                    isError = true
                    this.notEnough(this.getNowCanUseQty, this.getQty + totalExistedQty)
                }

                if(isError === false){
                    let duplicateData = 0
                    if(this.updateMode === false){
                        duplicateData = data.findIndex(a=>
                            a.pid === this.getComponentProduct['id'] &&
                            a.lid === this.getComponentLocation['id'] &&
                            a.remarks === this.getRemarks)
                    }else if(this.updateMode === true){
                        duplicateData = data.findIndex(a=>
                            a.pid === this.getComponentProduct['id'] &&
                            a.lid === this.getComponentLocation['id'] &&
                            a.remarks === this.getRemarks &&
                            a.id !==  this.updateItemID)
                    }

                    if(duplicateData === -1){
                        // No Same Data, add NEW
                        data.push({
                            "id": this.tablePKID,
                            "pid": this.getComponentProduct['id'],
                            "lid": this.getComponentLocation['id'],
                            "outCode": this.getComponentProduct['outCode'],
                            "innerCode": this.getComponentProduct['innerCode'],
                            "product_name": this.getComponentProduct['name_en'],
                            "location_name": this.getComponentLocation['location'] + ' ' + this.getComponentLocation['area'],
                            "qty": this.getQty,
                            "ctn": this.getCtn,
                            "remarks": this.getRemarks,
                        })

                        // if update mode, add new then delete old myself
                        if(this.updateMode === true){
                            data = data.filter(a => a.id !== this.updateItemID)
                        }
                    }else if(duplicateData > -1){
                        // Has Same Data, update OLD
                        if(this.updateMode === true) {
                            // update old data to new
                            let newData = {
                                "id": data[duplicateData]['id'],
                                "pid": this.getComponentProduct['id'],
                                "lid": this.getComponentLocation['id'],
                                "outCode": this.getComponentProduct['outCode'],
                                "innerCode": this.getComponentProduct['innerCode'],
                                "product_name": this.getComponentProduct['name_en'],
                                "location_name": this.getComponentLocation['location'] + ' ' + this.getComponentLocation['area'],
                                "qty": this.getQty + data[duplicateData]['qty'],
                                "ctn": Math.round((this.getQty + data[duplicateData]['qty']) / this.ctnQty * 10000) / 10000,
                                "remarks": this.getRemarks,
                            }
                            data[duplicateData] = {
                                ...data[duplicateData],
                                ...newData
                            }

                            // if update mode, add new then delete old myself
                            data = data.filter(a => a.id !== this.updateItemID)

                        }else if(this.updateMode === false) {
                            // old data add new data (But no need delete myself, cuz no myself)
                            // let gotTheItem = false
                            data[duplicateData] = {
                                "id": data[duplicateData]['id'],
                                "pid": this.getComponentProduct['id'],
                                "lid": this.getComponentLocation['id'],
                                "outCode": this.getComponentProduct['outCode'],
                                "innerCode": this.getComponentProduct['innerCode'],
                                "product_name": this.getComponentProduct['name_en'],
                                "location_name": this.getComponentLocation['location'] + ' ' + this.getComponentLocation['area'],
                                "qty": this.getQty + data[duplicateData]['qty'],
                                "ctn": Math.round((this.getQty + data[duplicateData]['qty']) / this.ctnQty * 10000) / 10000,
                                "remarks": this.getRemarks,
                            }
                        }
                    }
                    this.tablePKID += 1
                    this.tabulator.setData(data)
                    this.clearInputData()
                    this.updateMode = false
                }else{
                    console.log("Error on Write Off add to table")
                }
            }else{
                this.$swal.fire({
                    title: this.$t('error_input_stock_in_field_required'),
                    icon: "warning"
                })
            }
        },
        cancelUpdateMode(res){
            this.updateMode = false
            this.clearInputData()
        },
        notEnough(nowCanUse, getNowQty){
            this.$swal.fire({
                title: this.$t('error_stock_not_enough'),
                text: this.$t('error_stock_not_enough_details') + nowCanUse + ', ' +
                    this.$t('error_stock_not_enough_get') + getNowQty,
                icon: 'warning'
            })
            this.$refs.qtyProcessor.clearMode()
        },
        clearInputData(){
            this.getQty = ""
            this.getCtn = ""
            this.getRemarks = ""
            this.$refs.qtyProcessor.clearMode()
            this.canInputNumber = false
            this.$refs.filterDetailContentBox.resetProductSearch()
            this.$refs.stockCalculatedLocationBox.clearData()
        },
    },
    mounted() {
        document.title = this.$t('title') + ' | ' + this.$t('inventory_stock_write_off')

        this.tabulator = new Tabulator(this.$refs.tabulatorTableUse, {
            placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
            data: [],
            columns: [
                {title: "pid", field: 'pid', visible: false},
                {title: "lid", field: 'lid', visible: false},
                {title: "id", field: 'id', resizable: false, sorter: 'number', width: 10, responsive: 0,},
                {
                    title: this.$t('product_outCode_short'), field: 'outCode', sorter: 'string', resizable: false,
                    responsive: 0, minWidth: 250, width: 250,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('product_innerCode'), field: 'innerCode', sorter: 'string', resizable: false,
                    responsive: 0, minWidth: 250, width: 250,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('product_product_en'), field: 'product_name', sorter: 'string', resizable: true,
                    responsive: 1, minWidth: 250, width: 250,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_location'), field: 'location_name', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 1,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_qty'), field: 'qty', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 1,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_ctn'), field: 'ctn', sorter: 'string', resizable: true,
                    responsive: 1,widthGrow: 1,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_remarks'), field: 'remarks', sorter: 'string', resizable: false,
                    responsive: 1, minWidth: 300, width: 300,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    formatter: () => {
                        return "<i class='bi bi-pencil-fill'></i>"
                    },
                    headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", resizable: false,
                    headerSort: false, width: 10, responsive: 0,
                    cellClick: (e, row, formatterParams) => {
                        this.updateMode = true
                        this.needReloadList = false
                        this.updateItemID = row.getData().id
                        this.$refs.filterDetailContentBox.updateModeChange(row.getData().outCode)
                        this.$refs.stockCalculatedLocationBox.updateMode({
                            "pid": row.getData().pid,
                            "lid": row.getData().lid,
                            "sid": "''"
                        })
                        this.$refs.qtyProcessor.updateModeOnQty({
                            "qty": row.getData().qty,
                            "ctn": row.getData().ctn
                        })
                        this.getQty = row.getData().qty
                        this.getCtn = row.getData().ctn
                        this.getRemarks = row.getData().remarks
                    }
                },
                {
                    formatter: () => {
                        return "<i class='bi bi-trash-fill'></i>"
                    },
                    headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", resizable: false,
                    headerSort: false, width: 10, responsive: 0,
                    cellClick: (e, row, formatterParams) => {
                        this.$swal.fire({
                            title: this.$t('common_confirm_action_delete'),
                            icon: 'info'
                        }).then(result => {
                            if(result.isConfirmed){
                                let data = this.tabulator.getData()
                                data = data.filter(a => a.id !== row.getData().id)
                                this.tabulator.setData(data)
                            }
                        })
                    }
                },
            ],
            reactiveData: true, //enable data reactivity
            maxHeight: '90vh',
            responsiveLayout: 'collapse',
            layout: "fitColumns",
            movableColumns: true,
            movableRows: false,
            initialSort: [
                {column: "id", dir: "asc"},
            ],
            rowFormatter: (row, e) => {
                if (row.getData().is_error === true) {
                    row.getElement().style.backgroundColor = "#fac3c3"
                }
            }
        })
    }
}
</script>

<style scoped>

</style>
